"use strict";Object.defineProperty(exports, "__esModule", {value: true});const publicBaseUrl = 'https://www.bloomtext.com'

 const homepageUrl = publicBaseUrl; exports.homepageUrl = homepageUrl
 const pricingUrl = `${publicBaseUrl}/pricing/`; exports.pricingUrl = pricingUrl

 const supportUrl = `${publicBaseUrl}/support/`; exports.supportUrl = supportUrl
// The public API and integrations guide (the website's /integrate/ page).
 const apiIntegrationsUrl = `${publicBaseUrl}/integrate/`; exports.apiIntegrationsUrl = apiIntegrationsUrl
 const termsUrl = `${publicBaseUrl}/support/terms/`; exports.termsUrl = termsUrl
 const broadcastSupportUrl = `${publicBaseUrl}/support/broadcast-messaging/`; exports.broadcastSupportUrl = broadcastSupportUrl

 const scheduleMeetingUrl = 'https://calendly.com/tyler-bloom/bloomtext-support'; exports.scheduleMeetingUrl = scheduleMeetingUrl
 const scheduleDemoUrl = 'https://calendly.com/tyler-bloom/bloomtext-demo'; exports.scheduleDemoUrl = scheduleDemoUrl

 const smsMessagingDemoVideoUrl = 'https://player.vimeo.com/video/698401914?h=9d91347818&autoplay=1'; exports.smsMessagingDemoVideoUrl = smsMessagingDemoVideoUrl
// The broadcast how-to guide on the docs site.
 const broadcastDocsUrl = `${publicBaseUrl}/how-to/broadcasts/overview/`; exports.broadcastDocsUrl = broadcastDocsUrl
